export const COMPANY_TAB = {
  label: "Company",
  id: "company",
  index: 0,
  columnPickerdimensionName: "TPRCompanyColumnPicker",
};

export const VS_PEERS_TAB = {
  label: "Vs Peers",
  id: "peers",
  index: 1,
  columnPickerdimensionName: "TPRMultiCompanyColumnPicker",
};

export const INDIVIDUAL_CONTRIBUTOR_DISCLAIMERS =
  "For individual contributor disclaimers, see supporting documents.";

export const BROKER_DETAIL_GRID_SORT_KEYS = [
  "broker",
  "analyst",
  "publish_date",
  "status",
  "broker_rating",
  "normalized_rating",
  "target_price",
  "current_implied_return",
  "documents",
  "broker_rating_action",
  "price_at_date_published",
  "implied_return",
  "realized_return",
  "unrealized_return",
  "default",
];

export const BROKER_DETAIL_GRID_DEFAULT_COLUMNS = [
  "broker",
  "analyst",
  "publish_date",
  "status",
  "broker_rating",
  "normalized_rating",
  "target_price",
  "current_implied_return",
  "documents",
  "broker_rating_action",
  "price_at_date_published",
  "implied_return",
  "realized_return",
  "unrealized_return",
];

export const COLUMNS_WITH_AVERAGE_MEDIAN_DATA = [
  "target_price",
  "current_implied_return",
];

export const BROKER_DETAIL_GRID_COLUMN_MAPPING = {
  broker: {
    width: "180px",
    id: "broker",
    label: "Broker",
    showSort: true,
    renderer: "link",
    cellTextAlignment: "left",
  },
  analyst: {
    width: "180px",
    id: "analyst",
    label: "Analyst",
    showSort: true,
    renderer: "target-pricing-analyst",
    cellTextAlignment: "left",
  },
  publish_date: {
    width: "140px",
    id: "publish_date",
    label: "Last Change",
    showSort: true,
    renderer: "target-pricing-last-change",
    cellTextAlignment: "left",
  },
  status: {
    width: "110px",
    id: "status",
    label: "Consensus Status",
    showSort: true,
    renderer: "target-pricing-consensus",
    cellTextAlignment: "left",
  },
  broker_rating: {
    width: "110px",
    id: "broker_rating",
    label: "Analyst Rating",
    showSort: true,
    renderer: "colored-text",
    cellTextAlignment: "left",
  },
  normalized_rating: {
    width: "120px",
    id: "normalized_rating",
    label: "Normalized Rating",
    showSort: true,
    renderer: "badge",
    cellTextAlignment: "left",
  },
  target_price: {
    width: "100px",
    id: "target_price",
    label: "Target Price",
    showSort: true,
    renderer: "target-pricing-consensus",
    cellTextAlignment: "right",
  },
  current_implied_return: {
    width: "140px",
    id: "current_implied_return",
    label: "Current Implied Return",
    showSort: true,
    renderer: "colored-text",
    cellTextAlignment: "right",
  },
  documents: {
    width: "120px",
    id: "documents",
    label: "Documents",
    showSort: false,
    renderer: "icon-link",
    cellTextAlignment: "left",
  },
  broker_rating_action: {
    width: "100px",
    id: "broker_rating_action",
    label: "Rating Action",
    showSort: true,
    renderer: "colored-text",
    cellTextAlignment: "left",
  },
  price_at_date_published: {
    width: "100px",
    id: "price_at_date_published",
    label: "Price at Last Change",
    showSort: true,
    renderer: "colored-text",
    cellTextAlignment: "right",
  },
  implied_return: {
    width: "120px",
    id: "implied_return",
    label: "Target Implied Return",
    showSort: true,
    renderer: "colored-text",
    cellTextAlignment: "right",
  },
  realized_return: {
    width: "100px",
    id: "realized_return",
    label: "Realized Return",
    showSort: true,
    renderer: "colored-text",
    cellTextAlignment: "right",
  },
  unrealized_return: {
    width: "100px",
    id: "unrealized_return",
    label: "Unrealized Return",
    showSort: true,
    renderer: "colored-text",
    cellTextAlignment: "right",
  },
};

export const BROKER_DETAIL_GRID_DEFAULT_SORTING_ID = "default";

export const TPR_BROKER_DETAIL_COLUMN_PICKER_ITEMS = [
  {
    id: BROKER_DETAIL_GRID_COLUMN_MAPPING.broker.id,
    name: BROKER_DETAIL_GRID_COLUMN_MAPPING.broker.label,
    isSelected: true,
    isDisabled: false,
    isDraggable: false,
    isRemovable: false,
    index: 0,
  },
  {
    id: BROKER_DETAIL_GRID_COLUMN_MAPPING.analyst.id,
    name: BROKER_DETAIL_GRID_COLUMN_MAPPING.analyst.label,
    isSelected: true,
    isDisabled: false,
    isDraggable: true,
    isRemovable: false,
    index: 1,
  },
  {
    id: BROKER_DETAIL_GRID_COLUMN_MAPPING.publish_date.id,
    name: BROKER_DETAIL_GRID_COLUMN_MAPPING.publish_date.label,
    isSelected: true,
    isDisabled: false,
    isDraggable: true,
    isRemovable: false,
    index: 2,
  },
  {
    id: BROKER_DETAIL_GRID_COLUMN_MAPPING.status.id,
    name: BROKER_DETAIL_GRID_COLUMN_MAPPING.status.label,
    isSelected: true,
    isDisabled: false,
    isDraggable: true,
    isRemovable: false,
    index: 3,
  },
  {
    id: BROKER_DETAIL_GRID_COLUMN_MAPPING.broker_rating.id,
    name: BROKER_DETAIL_GRID_COLUMN_MAPPING.broker_rating.label,
    isSelected: true,
    isDisabled: false,
    isDraggable: true,
    isRemovable: false,
    index: 4,
  },
  {
    id: BROKER_DETAIL_GRID_COLUMN_MAPPING.normalized_rating.id,
    name: BROKER_DETAIL_GRID_COLUMN_MAPPING.normalized_rating.label,
    isSelected: true,
    isDisabled: false,
    isDraggable: true,
    isRemovable: false,
    index: 5,
  },
  {
    id: BROKER_DETAIL_GRID_COLUMN_MAPPING.target_price.id,
    name: BROKER_DETAIL_GRID_COLUMN_MAPPING.target_price.label,
    isSelected: true,
    isDisabled: false,
    isDraggable: true,
    isRemovable: false,
    index: 6,
  },
  {
    id: BROKER_DETAIL_GRID_COLUMN_MAPPING.current_implied_return.id,
    name: BROKER_DETAIL_GRID_COLUMN_MAPPING.current_implied_return.label,
    isSelected: true,
    isDisabled: false,
    isDraggable: true,
    isRemovable: false,
    index: 7,
  },
  {
    id: BROKER_DETAIL_GRID_COLUMN_MAPPING.documents.id,
    name: BROKER_DETAIL_GRID_COLUMN_MAPPING.documents.label,
    isSelected: true,
    isDisabled: false,
    isDraggable: true,
    isRemovable: false,
    index: 8,
  },
  {
    id: BROKER_DETAIL_GRID_COLUMN_MAPPING.broker_rating_action.id,
    name: BROKER_DETAIL_GRID_COLUMN_MAPPING.broker_rating_action.label,
    isSelected: false,
    isDisabled: false,
    isDraggable: true,
    isRemovable: true,
    index: 9,
  },
  {
    id: BROKER_DETAIL_GRID_COLUMN_MAPPING.price_at_date_published.id,
    name: BROKER_DETAIL_GRID_COLUMN_MAPPING.price_at_date_published.label,
    isSelected: false,
    isDisabled: false,
    isDraggable: true,
    isRemovable: true,
    index: 10,
  },
  {
    id: BROKER_DETAIL_GRID_COLUMN_MAPPING.implied_return.id,
    name: BROKER_DETAIL_GRID_COLUMN_MAPPING.implied_return.label,
    isSelected: false,
    isDisabled: false,
    isDraggable: true,
    isRemovable: true,
    index: 11,
  },
  {
    id: BROKER_DETAIL_GRID_COLUMN_MAPPING.realized_return.id,
    name: BROKER_DETAIL_GRID_COLUMN_MAPPING.realized_return.label,
    isSelected: false,
    isDisabled: false,
    isDraggable: true,
    isRemovable: true,
    index: 12,
  },
  {
    id: BROKER_DETAIL_GRID_COLUMN_MAPPING.unrealized_return.id,
    name: BROKER_DETAIL_GRID_COLUMN_MAPPING.unrealized_return.label,
    isSelected: false,
    isDisabled: false,
    isDraggable: true,
    isRemovable: true,
    index: 13,
  },
];

export const TPR_VSPEERS_PRICE_PERFORMANCE_OPTIONS = [
  { key: "1M", value: "1M" },
  { key: "3M", value: "3M" },
  { key: "6M", value: "6M" },
  { key: "1Y", value: "1Y" },
];

export const RATINGS = "Ratings";
export const PRICE_TARGET_RETURNS = "Price, Targets & Returns";
export const PRICE_PERFORMANCE = "Price Performance";
export const EPS =
  "EPS-Diluted-Applicable to Common Stockholders, Primary(Abs)";
export const TOTAL_REVENUE_PRIMARY = "Total Revenue, primary(M)";
export const SUB_COLUMNS_WITHOUT_LOADER = [
  "price",
  "target_price",
  "consensus_values",
  "rating_distribution",
];

export const TPR_PAGE = "TPR_PAGE";

export const TPR_LOG_ACTION_FEATURES = {
  visitPage: "TPR_PAGE_VISIT",
  companyTabSelection: "TPR_COMPANY_TAB_SELECTION",
  companyPieSelection: "TPR_COMPANY_DISTRIBUTION_PIE_SELECTION",
  companyUpdateColumnPicker: "TPR_COMPANY_UPDATE_COLUMN",
  companyDataPointClick: "TPR_COMPANY_DATAPOINT_CLICK",
  companyDocumentsOpened: "TPR_COMPANY_DOCUMENTS_MODAL_OPENED",
  companyFilingsWithGuidanceOpened: "FILINGS_WITH_GUIDANCE",
  companyFilingsWithoutGuidanceOpened: "FILINGS_WITHOUT_GUIDANCE",
  companyDocumentTypeChange: "TPR_COMPANY_DOCUMENT_TYPE_CHANGE",
  companyDocumentToggleChange: "TPR_COMPANY_DOCUMENTS_TOGGLE_PRIMARY",
  companyDocumentTitleClick: "TPR_COMPANY_DOCUMENT_RESEARCH_TITLE_CLICK",
  companyResearchDocumentDownload: "TPR_COMPANY_RESEARCH_DOCUMENT_DOWNLOAD",
  companyModelDocumentDownload: "TPR_COMPANY_MODEL_DOCUMENT_DOWNLOAD",
  companyDocumentPrint: "TPR_COMPANY_DOCUMENT_PRINT",
  companyAnalystTooltipEmail: "TPR_COMPANY_ANALYST_TOOLTIP_EMAIL_CLICK",
  companyBrokerGridSort: "TPR_COMPANY_BROKER_GRID_SORT",
  peersTabSelection: "TPR_PEERS_TAB_SELECTION",
  peersCurrencyUpdate: "TPR_VSPEERS_UPDATE_CURRENCY",
  peersPricePerformanceUpdate: "TPR_VSPEERS_UPDATE_PRICE_PERFORMANCE",
  peersColumnPickerUpdate: "TPR_VSPEERS_UPDATE_COLUMN",
  peersTickerUpdate: "TPR_VSPEERS_UPDATE_TICKER",
  peersDatapointClick: "TPR_VSPEERS_DATAPOINT_CLICK",
  peersGridSort: "TPR_VSPEERS_GRID_SORT",
};

export const TPR_VSPEERS_GRID_COLUMNS = {
  "Price, Targets & Returns": {
    subColumnHeaders: {
      10: "Last Price, EOD",
      target_price: "Target Price",
      "83|NTM": "Current Implied Return",
      "5656|NTM": "EPS 1-year average growth",
      "82|NTM": "Multiple Expansion",
    },
  },
  Ratings: {
    subColumnHeaders: {
      consensus_values: "Consensus",
      rating_distribution: "Distribution",
    },
  },
  "Price Performance": {
    subColumnHeaders: {
      10: "Price Performance",
    },
  },
  "Price/Earnings, NTM": {
    subColumnHeaders: {
      "30|NTM": "Current",
      "86|NTM": "Target",
    },
  },
  "Price/Sales, NTM": {
    subColumnHeaders: {
      "31|NTM": "Current",
      "87|NTM": "Target",
    },
  },
  "EPS-Diluted-Applicable to Common Stockholders, Primary(Abs)": {
    subColumnHeaders: {
      "5656|LTM": "LTM",
      "5656|NTM": "NTM",
      "5656|STM": "STM",
    },
  },
  "Total Revenue, primary(M)": {
    subColumnHeaders: {
      "5652|LTM": "LTM",
      "5652|NTM": "NTM",
      "5652|STM": "STM",
    },
  },
};
